/**
 * Calculates distance between browsers current location and a given latitude
 * and longitude
 *
 * @param {number} lat - given latitude
 * @param {number} lon - given longitude
 * @returns {Promise<number | null>} - a promise that will either return distance
 * between current location and given latitude/longitude or null(if browser 
 * location is not activated)
 * @example
 * distanceFromMe(50, 70)
 *  .then((distance) => console.log("distance between current location and latLon[50, 70]"))
 */
export const distanceFromMe = (
  lat: number, lon: number
): Promise<number | null> => new Promise((resolve, reject) => {
  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition((position) => {
      const lat1 = position.coords.latitude;
      const lon1 = position.coords.longitude;
      const lat2 = lat;
      const lon2 = lon;

      // Calculate distance using Haversine formula
      const R = 6371; // Radius of earth in km
      const dLat = (lat2 - lat1) * Math.PI / 180;
      const dLon = (lon2 - lon1) * Math.PI / 180;
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c;

      resolve(Math.round(distance * 0.621371)); // Convert to miles and round
    }, (error) => {
      console.log("erro", error);
      reject(error);
    });
  } else {
    return null;
  }
});